export default __webpack_public_path__ + "img/ds-logo.52bdfb2a.png";